import { render, staticRenderFns } from "./PatientChartScoreHistoryModal.vue?vue&type=template&id=5a72016b"
import script from "./PatientChartScoreHistoryModal.vue?vue&type=script&lang=js"
export * from "./PatientChartScoreHistoryModal.vue?vue&type=script&lang=js"
import style0 from "./PatientChartScoreHistoryModal.vue?vue&type=style&index=0&id=5a72016b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports